import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "my-2" }
const _hoisted_3 = { class: "py-6 text-center mx-auto max-w-6xl" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center bg-white border-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-4 text-gray-700 text-base"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_ExplorerNavigation = _resolveComponent("ExplorerNavigation")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ExplorerTable = _resolveComponent("ExplorerTable")!
  const _component_RemoteContent = _resolveComponent("RemoteContent")!
  const _component_HowToQuote = _resolveComponent("HowToQuote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SectionHeader, {
      infoText: _ctx.$t('explorer.info')
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", {
          innerHTML: _ctx.$t('explorer.title')
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["infoText"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoaded(_ctx.compactOverview))
        ? (_openBlock(), _createBlock(_component_ExplorerNavigation, {
            key: 0,
            "show-filters": _ctx.showFilters,
            "filter-values": _ctx.filterValues,
            onToggleFilters: _ctx.toggleFilters,
            onResetFilters: _ctx.resetFilters
          }, null, 8, ["show-filters", "filter-values", "onToggleFilters", "onResetFilters"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoaded(_ctx.compactOverview))
      ? (_openBlock(), _createBlock(_component_i18n_t, {
          key: 0,
          keypath: "explorer.explanation",
          tag: "p",
          for: "explorer.overview_link",
          class: "text-center showLinks"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: { name: 'ExplorerOverview' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('explorer.overview_link')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_RemoteContent, { data: _ctx.compactOverview }, {
        default: _withCtx(() => [
          (_ctx.isLoaded(_ctx.compactOverview))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ExplorerTable, {
                  rows: _ctx.optimizedRows,
                  "sort-key": _ctx.sortKey,
                  "sort-asc": _ctx.sortAsc,
                  "show-filters": _ctx.showFilters,
                  "filter-values": _ctx.filterValues,
                  onSort: _ctx.sortBy,
                  onUpdateFilter: _ctx.debouncedUpdateFilter
                }, null, 8, ["rows", "sort-key", "sort-asc", "show-filters", "filter-values", "onSort", "onUpdateFilter"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"]),
      (_ctx.isLoaded(_ctx.compactOverview))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('explorer.verse_count_label', { count: _ctx.totalFilteredRows })), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoaded(_ctx.compactOverview))
      ? (_openBlock(), _createBlock(_component_HowToQuote, {
          key: 1,
          citation: _ctx.$t('explorer.how_to_cite')
        }, null, 8, ["citation"]))
      : _createCommentVNode("", true)
  ], 64))
}